/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} From_Your_DashboardInputs */

const en_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from your dashboard.`)
};

const es_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`desde tu panel.`)
};

const fr_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depuis votre tableau de bord.`)
};

const de_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`von deinem Dashboard aus.`)
};

const ja_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュボードから。`)
};

const zh_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从您的仪表板开始。`)
};

const ar_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من لوحة التحكم الخاصة بك.`)
};

const id_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dari dasbor Anda.`)
};

const it_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dalla tua dashboard.`)
};

const ru_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`из панели управления.`)
};

const pt_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`do seu painel.`)
};

const ko_from_your_dashboard = /** @type {(inputs: From_Your_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드에서 시작하세요.`)
};

/**
* | output |
* | --- |
* | "from your dashboard." |
*
* @param {From_Your_DashboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const from_your_dashboard = /** @type {((inputs?: From_Your_DashboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<From_Your_DashboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_from_your_dashboard(inputs)
	if (locale === "es") return es_from_your_dashboard(inputs)
	if (locale === "fr") return fr_from_your_dashboard(inputs)
	if (locale === "de") return de_from_your_dashboard(inputs)
	if (locale === "ja") return ja_from_your_dashboard(inputs)
	if (locale === "zh") return zh_from_your_dashboard(inputs)
	if (locale === "ar") return ar_from_your_dashboard(inputs)
	if (locale === "id") return id_from_your_dashboard(inputs)
	if (locale === "it") return it_from_your_dashboard(inputs)
	if (locale === "ru") return ru_from_your_dashboard(inputs)
	if (locale === "pt") return pt_from_your_dashboard(inputs)
	return ko_from_your_dashboard(inputs)
});